import React from 'react';
import { connect } from 'react-redux';
import { showModalMessage } from '../store/modalsSlice';
import EditingDataHistoryDialog from '../components/editingDataHistoryDialog';
import WebViewerLicenseHistoryTable from '../components/webViewerLicenseHistoryTable';
import * as objectHistory from '../store/objectHistorySlice';
import { objectHistoryNames, objectHistorySelectors } from '../store/objectHistorySlice';
import { webViewerLicensesSelectors } from '../store/webViewerLicensesSlice';
import WebViewerLicenseHistoryTableHeader from '../components/webViewerLicenseHistoryTableHeader';

class WebViewerLicenseHistoryDialog extends EditingDataHistoryDialog {
  get dataId() {
    return this.props.id;
  }

  get Title() {
    return 'Web viewer license history';
  }

  renderTable(tableProps) {
    return <WebViewerLicenseHistoryTable {...tableProps}/>
  }

  renderBeforeContent() {
    const objectData = this.props.selectedWebViewerLicenses(this.props.id);
    const editedFields = this.props.getEditedFields();
    return <WebViewerLicenseHistoryTableHeader editedFields={editedFields} objectData={objectData}/>;
  }

  getLoaderMessage() {
    return 'Web viewer license history loading...';
  }
}

const mapStateToProps = (state) => ({
  objectState: objectHistorySelectors.webViewerLicenses(state),
  getEditedFields: () => objectHistorySelectors.webViewerLicensesEditedFields(state),
  selectedWebViewerLicenses: (id) => webViewerLicensesSelectors.selectById(state, id),
});

const actionCreators = {
  fetchHistory: (webViewerLicenseId) => objectHistory.fetchHistory(webViewerLicenseId, objectHistoryNames.webViewerLicenses),
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(WebViewerLicenseHistoryDialog);



// WEBPACK FOOTER //
// ./src/containers/webViewerLicenseHistoryDialog.js